import React from 'react';
import './Filter.css';
import { useContext } from 'react';
import filterContext from '../../context/filters/filterContext';
import Checkbox from 'antd/es/checkbox';
function Datefilter() {
	const { onChange } = useContext(filterContext);
	const {
		selectedDate,
		setSelectedDate,
		nameOfdate,
		setnameOfdate,
	} = useContext(filterContext);
	// const handleDateChange = (event) => {
	//   const dateValue = event.target.value;
	//   setSelectedDate(dateValue);
	// };
	return (
		<>
			<div
				className="filterStyle"
				style={{
					display: 'flex',
					background: 'transparent',
					flexDirection: 'column',
					gap: '5px',
					alignItems: 'unset',
				}}
			>
				<label
					htmlFor="input-field1"
					className="labelStyle"
					style={{ width: '100%', fontSize: '15px' }}
				>
					From
				</label>
				<input
					id="input-field1"
					type="date"
					name="fromDate"
					onChange={onChange}
					value={nameOfdate.fromDate}
					max={new Date().toISOString().split('T')[0]}
					disabled={nameOfdate.date}
					style={{
						backgroundColor: '#3b535e',
						border: 'none',
						fontSize: 'revert',
						padding: '10px',
					}}
				/>
			</div>
			<hr />
			<div
				className="filterStyle"
				style={{
					display: 'flex',
					background: 'transparent',
					flexDirection: 'column',
					gap: '5px',
					alignItems: 'unset',
				}}
			>
				<label
					htmlFor="input-field"
					className="labelStyle"
					style={{ width: '100%', fontSize: '15px' }}
				>
					To
				</label>
				<input
					id="input-field"
					className="checkboxStyle"
					type="date"
					name="toDate"
					onChange={onChange}
					value={nameOfdate.toDate}
					min={nameOfdate.fromDate}
					max={new Date().toISOString().split('T')[0]}
					disabled={nameOfdate.date}
					style={{
						backgroundColor: '#3b535e',
						border: 'none',
						fontSize: 'revert',
						padding: '10px',
					}}
				/>
			</div>
			<hr />
			<div
				className="filterStyle"
				style={{
					display: 'flex',
					background: 'transparent',
					flexDirection: 'column',
					gap: '5px',
					alignItems: 'unset',
				}}
			>
				<label
					htmlFor="input-field2"
					className="labelStyle"
					style={{ width: '100%', fontSize: '15px' }}
				>
					Select a particular date
				</label>
				<input
					className="checkboxStyle"
					id="input-field2"
					type="date"
					name="date"
					onChange={onChange}
					value={nameOfdate.date}
					max={new Date().toISOString().split('T')[0]}
					disabled={nameOfdate.fromDate || nameOfdate.toDate}
					style={{
						backgroundColor: '#3b535e',
						border: 'none',
						fontSize: 'revert',
						padding: '10px',
					}}
				/>
			</div>
			<hr />
		</>
	);
}
export default Datefilter;
